module.exports = __webpack_public_path__ + "img/2019-01-Arab-Health.9483c35d.png";